import { render } from "./CatPage.vue?vue&type=template&id=b35b867c"
import script from "./CatPage.vue?vue&type=script&lang=js"
export * from "./CatPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__